<script>
  import AnimatedValue from '../core/dataviz/AnimatedValue.svelte'

  export let label = undefined
  export let value = undefined
  export let prefix = ''
  export let suffix = ''

  export let phraseMode = false
  export let linkUrl = undefined

  export let animateNumbers = false
  let valueToAnimate = undefined

  $: {
    if(animateNumbers && typeof value === 'string' ) {
      // attempt to cleanup the value, then make it a number
      valueToAnimate = Number(value.replace(/\$|,/g, ''))
    } else if(animateNumbers && typeof value === 'number') {
      valueToAnimate = value
    } else if(typeof value === 'string') {
      valueToAnimate = value
    }
  }
</script>

<p class="label-value-couplet{ phraseMode ? ' phrase-mode' : '' }{ animateNumbers ? ' animated-numbers' : '' }">
  { #if animateNumbers && valueToAnimate }
    { label }
     <AnimatedValue { prefix } value={ valueToAnimate } { suffix } /> 
  { :else if !phraseMode }
    { #if linkUrl }
      { label }
      { prefix } <a href="{ linkUrl }" target="_blank" rel="noreferrer"> { @html value } { suffix }</a>
    { :else }
      { label }
      { prefix } { @html value } { suffix }
    { /if }
  { :else }
    { #if linkUrl } 
      { prefix } <a href="{ linkUrl }" target="_blank" rel="noreferrer"> { @html value } { label } { suffix }</a>
    { :else }
      { prefix } { @html value } { label } { suffix }
    {/if }
  { /if }
</p>

<style>
  p {
    color: #e00122;
    font-size: 2rem;
    margin: 0;
    text-align: center;
    font-weight: 700;
    margin: 0 0 1.5rem;
  }

  p.phrase-mode {
    color: #464646;
  }

  a {
    color: #e00122;
  }
</style>